import React from "react";
import Link from "next/link";

import Brand from "../Typography/Brand/Brand";
import styles from "./Footer.module.scss";
import {
  LogoDiscord,
  SendAltFilled,
} from "@carbon/icons-react";

interface FooterProps {
  hideSocialIcons?: boolean;
  hideBackground?: boolean;
}

const Footer = ({ hideSocialIcons, hideBackground }: FooterProps) => {
  return (
    <footer
      className={
        hideBackground
          ? `${styles.footerContainer} ${styles.hideBackground}`
          : styles.footerContainer
      }
    >
      <div className="flex justify-center items-center mt-4">
        <Brand styles={{ fontSize: "32px" }} />
      </div>

      <div className="flex justify-center gap-6 items-center mt-8">
        <a
          className="flex items-center gap-2 main !underline !underline-offset-4"
          href="https://discord.gg/yMzFzVUPDf"
          target="_blank"
          rel="noreferrer"
        >
          <LogoDiscord size={24} />
          Discord
        </a>

        <a
          className="flex items-center gap-2 main !underline !underline-offset-4"
          href="mailto:info@skingenerator.io"
        >
          <SendAltFilled size={24} />
          Contact Us
        </a>
      </div>

      <div className="mt-4 w-full text-center">
        <div className="flex justify-center items-center gap-6 mb-4">
          <Link className="main !underline !underline-offset-4" href="/terms">
            Terms of Service
          </Link>
          <span className="text-gray-600">•</span>
          <Link
            className="main !underline !underline-offset-4"
            href="/acceptable-use-policy"
          >
            Acceptable Use Policy
          </Link>
          <span className="text-gray-600">•</span>
          <Link
            className="main !underline !underline-offset-4"
            href="/privacy-policy"
          >
            Privacy Policy
          </Link>
          <span className="text-gray-600">•</span>
          <Link
            className="main !underline !underline-offset-4"
            href="/cookie-policy"
          >
            Cookie Policy
          </Link>
        </div>
      </div>

      <div className="signature flex white w-full justify-center mt-8">
        <a href="https://www.monadical.com" target="_blank" rel="noreferrer">
          Made with ♥️ by Monadical
        </a>
      </div>
    </footer>
  );
};

export default Footer;
